import { WATCHER__user_auth_failed } from '@/pages/_base/watchers/WATCHER__user_auth_failed';
import { WATCHER_GENERATION__autorun } from '@/pages/page_generation/_watchers/generation/WATCHER_GENERATION__autorun';
import { WATCHER_IMAGES__add_to_loading_pool } from '@/pages/page_generation/_watchers/images/WATCHER_IMAGES__add_to_loading_pool';
import { WATCHER__drag_and_drop } from '@/services/drag_and_drop/WATCHER__drag_and_drop';
import { WATCHER__app_info_maintenance } from '../pages/_base/app_info/WATCHER__app_info_maintenance';
import { WatcherDiffusionModelsReservationTimers } from '../pages/_base/watchers/diffusion_models/watcher_diffusion_models_reservation_timers';
import { WatcherDiffusionModelsTitle } from '../pages/_base/watchers/diffusion_models/watcher_diffusion_models_title';
import { WATCHER__generation_price_load_generation_prices } from '../pages/_base/watchers/generation_price/WATCHER__generation_price_load_generation_prices';
import { WATCHER__is_app_on_focus } from '../pages/_base/watchers/global/WATCHER__is_app_on_focus';
import { WATCHER__key_shift } from '../pages/_base/watchers/global/WATCHER__key_shift';
import { WatcherShortcutChangeLanguage } from '../pages/_base/watchers/language/watcher_shortcut_change_language';
import { WatcherLanguageChangeNotifier } from '../pages/_base/watchers/language/WatcherLanguageChangeNotifier';
import { WatcherLanguageFallbackFromDefault } from '../pages/_base/watchers/language/WatcherLanguageFallbackFromDefault';
import { WatcherLanguageFallbackPigdog } from '../pages/_base/watchers/language/WatcherLanguageFallbackPigdog';
import { WatcherLanguageFromBrowserToSettings } from '../pages/_base/watchers/language/WatcherLanguageFromBrowserToSettings';
import { WatcherLanguageFromSettingsToBrowser } from '../pages/_base/watchers/language/WatcherLanguageFromSettingsToBrowser';
import { WatcherLanguageLoader } from '../pages/_base/watchers/language/WatcherLanguageLoader';
import { WatcherResponseError } from '../pages/_base/watchers/responses/WatcherResponseError';
import { WatcherResponseLowBalance } from '../pages/_base/watchers/responses/WatcherResponseLowBalance';
import { WatcherLoginWithToken } from '../pages/_base/watchers/set_workspace_current/WatcherLoginWithToken';
import { WATCHER_DebugReloadPageAfterError } from '../pages/_base/watchers/WATCHER_debug_reload_page_after_error';
import { WatcherConnectionError } from '../pages/_base/watchers/WatcherConnectionError';
import { WatcherReactScanShowHide } from '../pages/_base/watchers/WatcherReactScanShowHide';
import { WatcherRemoveSplashStatic } from '../pages/_base/watchers/WatcherRemoveSplashStatic';
import { WatcherScreenResize } from '../pages/_base/watchers/WatcherScreenResize';
import { WatcherInvitationToWorkspace } from '../pages/_base/watchers/workspace/WatcherInvitationToWorkspace';
import { WatcherWorkspacePurchaseColor } from '../pages/_base/watchers/workspace/WatcherWorkspacePurchaseColor';
import { WatcherWorkspaceTransferProposal } from '../pages/_base/watchers/workspace/WatcherWorkspaceTransferProposal';
import { WatcherWorkspaceChildEntitySharingCollections } from '../pages/_base/watchers/workspace/workspace_entity_sharing/WatcherWorkspaceChildEntitySharingCollections';
import { WatcherWorkspaceChildEntitySharingSearch } from '../pages/_base/watchers/workspace/workspace_entity_sharing/WatcherWorkspaceChildEntitySharingSearch';
import { WatcherWorkspaceChildEntitySharingUserTask } from '../pages/_base/watchers/workspace/workspace_entity_sharing/WatcherWorkspaceChildEntitySharingUserTask';
import { WATCHER_IMAGES__load } from '../pages/page_generation/_watchers/images/WATCHER_IMAGES__load';
import { WATCHER_IMAGES__drag_and_drop_external } from '../pages/page_generation/_watchers/WATCHER_IMAGES__drag_and_drop_external';

export function WATCHERS__container_global_before_view() {
  return (
    <>
      {/*
       * WATCHERS
       */}
      <WATCHER__user_auth_failed />

      <WATCHER__drag_and_drop />

      <WATCHER_IMAGES__add_to_loading_pool />
      <WATCHER_IMAGES__load />
      <WATCHER_IMAGES__drag_and_drop_external />

      <WATCHER_DebugReloadPageAfterError />

      <WATCHER__app_info_maintenance />

      <WatcherRemoveSplashStatic />

      <WATCHER__generation_price_load_generation_prices />

      <WatcherWorkspaceChildEntitySharingCollections />
      <WatcherWorkspaceChildEntitySharingSearch />
      <WatcherWorkspaceChildEntitySharingUserTask />

      <WATCHER_GENERATION__autorun />

      {/*
       * DIFFUSION MODELS
       */}
      <WatcherDiffusionModelsReservationTimers />
      <WatcherDiffusionModelsTitle />

      <WatcherLoginWithToken />

      <WatcherScreenResize />

      <WatcherResponseLowBalance />

      <WatcherConnectionError />
      <WatcherResponseError />

      <WATCHER__key_shift />
      <WATCHER__is_app_on_focus />

      {/*
       * LAMGUAGE
       */}

      <WatcherLanguageChangeNotifier />
      <WatcherLanguageFallbackFromDefault />
      <WatcherLanguageFallbackPigdog />
      <WatcherLanguageFromBrowserToSettings />
      <WatcherLanguageFromSettingsToBrowser />
      <WatcherLanguageLoader />

      <WatcherShortcutChangeLanguage />

      {/*
       * TUTORIAL
       */}
      {/* <WatcherTutorialSendProgressKeyboardHint /> */}

      {/*
       * WORKSPACE
       */}

      <WatcherWorkspacePurchaseColor />

      <WatcherInvitationToWorkspace />
      <WatcherWorkspaceTransferProposal />

      <WatcherReactScanShowHide />
    </>
  );
}
